export default __webpack_public_path__ + "static/zappyeels-ab3730233e4592f7ea49938fcf04fcfc.webp";